//core
import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { getSymbolFromCode } from "currency-code-symbol-map";
import { useSelector } from "react-redux";

//styles
import { useStyles } from "./styles";

//routes
import routes from "../../../../../../../navigation/routes";

//hooks
import { usePermissions } from "../../../../../../../store/common/configuration/usePermissions";

//selectors

//components
import CardMenu from "../CardMenu";
import Status from "../../../../../../common/TableData/components/Status";
import FloatFormat from "../../../../../../common/TableData/components/FloatFormat";
import ClickableUserId from "../../../../../../common/TableData/components/ClickableUserId";
import { normalizeNumber } from "../../../../../../../helpers/utils";
import Text from "../../../../../../common/TableData/components/Text";
import DateTime from "../../../../../../common/TableData/components/DateTime";
import { hasItemArrayInArray } from "../../../../../../../helpers/hasStringInArray";
import DateTimeRange from "../../../../../../common/TableData/components/DateTimeRange";

interface IItemCardProps {
  data: any;
	columns: any;
}

const ItemCard: React.FC<IItemCardProps> = ({
  data,
  columns,
}): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();
  let history = useNavigate();
	const { hasPermissions } = usePermissions();

	const hasDetails = hasPermissions(["api3.admin.subaffiliatedealcontroller.subaffiliate_deal_list"]);
	const hasDelete = hasPermissions(["api3.admin.subaffiliatedealcontroller.subaffiliate_deal_delete"]);
	const hasEdit = hasPermissions(["api3.admin.subaffiliatedealcontroller.subaffiliate_deal_update"]);

	const hasShowField = (field: string) => {
		return hasItemArrayInArray([field], columns);
	};

  return (
    <Card className={styles.card} elevation={1}>
	    <Box className={styles.top}>
		    {
			    (hasDelete || hasEdit || hasDetails) && (
				    <CardMenu data={data} />
			    )
		    }
	    </Box>
	    {hasShowField('id') && (
		    <Box className={styles.field}>
			    <Typography className={styles.id_label} variant="body2" component="span">
				    {t("columns_for_display.table.generate_report.id")}
			    </Typography>
			    <Typography variant="body2" component="span">
				    <Text value={data.id} whiteSpace />
			    </Typography>
		    </Box>
	    )}
	    {hasShowField('title') && (
		    <Box className={styles.field}>
			    <Typography className={styles.title} variant="subtitle2" component="div">
				    {!!data.title ? data.title : ''}
			    </Typography>
	      </Box>
	    )}
	    {hasShowField('platformName') && (
		    <Box className={styles.field}>
		      <Typography className={styles.label} variant="body2" component="span">
		        {t("columns_for_display.table.generate_report.platformName")}:
		      </Typography>
			    <Typography variant="body2" component="span">
				    <Text value={data.platformName} whiteSpace />
			    </Typography>
		    </Box>
	    )}
	    {hasShowField('createdAt') && (
		    <Box className={styles.field}>
		      <Typography className={styles.label} variant="body2" component="span">
		        {t("columns_for_display.table.generate_report.createdAt")}:
		      </Typography>
			    <Typography variant="body2" component="span">
				    <DateTimeRange value={data.createdAt} fullDate/>
			    </Typography>
		    </Box>
	    )}
	    {hasShowField('createdBy') && (
		    <Box className={styles.field}>
	        <Typography className={styles.label} variant="body2" component="span">
		        {t("columns_for_display.table.generate_report.createdBy")}:
	        </Typography>
			    <Typography variant="body2" component="span">
				    <Text value={data.createdBy} whiteSpace />
			    </Typography>
	      </Box>
	    )}
	    {hasShowField('updatedBy') && (
		    <Box className={styles.field}>
		      <Typography className={styles.label} variant="body2" component="span">
		        {t("columns_for_display.table.generate_report.updatedBy")}:
		      </Typography>
			    <Typography variant="body2" component="span">
				    <Text value={data.updatedBy} whiteSpace />
			    </Typography>
		    </Box>
	    )}

    </Card>
  );
};

export default ItemCard;
